export default class MarkerIndex {
    constructor(markerGroups) {
        this.byIndex = markerGroups.map(g => g.markers_).reduce((acc, arr) => acc.concat(arr), []);
        this.byId = {};
        this.byOverlayFirst = {};
        this.byOverlayLast = {};

        this.byIndex.filter(m => m.markerButton_).forEach((marker, index) => {
            const markerObj = {
                index: index,
                marker: marker
            };

            this.byId[marker.markerButton_.id] = markerObj;
            this.byOverlayFirst[marker.firstOverlayFocus_.id] = markerObj;
            this.byOverlayLast[marker.lastOverlayFocus_.id] = markerObj;
        });

        this.lastItemIndex = this.byIndex.length - 1;
    }

    getWithNext(id) {
        if (!id) {
            return null;
        }

        if (this.byId[id] && !this.byId[id].marker.isOpen_) {
            return this.byId[id];
        } else if (this.byOverlayLast[id]) {
            return this.byOverlayLast[id];
        } else {
            return null;
        }
    }


    getNextMarker(id) {
       const withNext = this.getWithNext(id);
       return withNext && withNext.index < this.lastItemIndex ? this.byIndex[withNext.index + 1] : null;
    }

    getPrevMarker(id) {
        if (!id) {
            return null;
        }

        if (this.byId[id] && this.byId[id].index > 0) {
            const withPrev =  this.byId[id];
            const prev = this.byIndex[withPrev.index - 1];
            return prev.isOpen_ ? null : prev;
        } else if (this.byOverlayFirst[id]) {
            return this.byOverlayFirst[id].marker;
        } else {
            return null;
        }
    }
}